import {Component, Inject, OnInit} from '@angular/core';
import { ContractService } from 'src/app/services/contract_service.service';
import { Contract } from 'src/app/models/contract.model';
import { ContractComponent } from '../../contract/contract.component';
import { MAT_DIALOG_DATA, MatDialog, MatDialogClose } from '@angular/material/dialog';
import { MatProgressBar } from '@angular/material/progress-bar';
import { MatTable, MatColumnDef, MatHeaderCellDef, MatHeaderCell, MatCellDef, MatCell, MatHeaderRowDef, MatHeaderRow, MatRowDef, MatRow } from '@angular/material/table';
import { MatIconButton, MatButton } from '@angular/material/button';
import { MatTooltip } from '@angular/material/tooltip';
import { MatIcon } from '@angular/material/icon';
import { DatePipe } from '@angular/common';

@Component({
    selector: 'provider-data-dialog',
    templateUrl: './provider_data_dialog.component.html',
    styleUrls: ['./provider_data_dialog.component.scss'],
    imports: [MatProgressBar, MatTable, MatColumnDef, MatHeaderCellDef, MatHeaderCell, MatCellDef, MatCell, MatIconButton, MatTooltip, MatIcon, MatButton, MatHeaderRowDef, MatHeaderRow, MatRowDef, MatRow, MatDialogClose, DatePipe]
})
export class ProviderDataDialogComponent implements OnInit {

    displayedColumns: string[] = ['updateDate', 'approvalStatus', 'actions'];
    contracts: Contract[] = [];
    loading = true;
    errorMessage: string | null = null;

    constructor(
        @Inject(MAT_DIALOG_DATA) public data: { providerId: string },
        public dialog: MatDialog,
        private contractService: ContractService,
    ) {}

    ngOnInit(): void {
        this.load();
    }

    load(): void {
        this.loading = true;
        this.errorMessage = null;

        const map = new Map([
            ['serviceProviderId', this.data.providerId]
        ]);

        this.contractService.getAll([], map).subscribe(response => {
            this.contracts = response;
            this.loading = false;
        }, (error) => {
            this.loading = false;
            this.errorMessage = error;
        });
    }

    readContract(contractId: string): void {
        this.dialog.open(ContractComponent, {data: {contractId}});
    }
}
